const surfGreen500Color = '#80ac9e';

export default surfGreen500Color;
